export function hideItem(el){
    if (el) {
      if (el.classList) {
        el.classList.remove("menuitemVisible");
        el.classList.add("menuitemHidden");
      }
    }
  }